<template>
  <v-btn
    :prepend-icon="`fas ${icon}`"
    :text="name"
    size="small"
    color="primary"
    @click="copySignedUrl"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useErrorStore } from '@/stores/errors';

const props = withDefaults(defineProps<{
  model: object;
  name?: string;
  field?: string;
  icon?: string;
}>(), {
  name: () => useI18n().t('url.copy'),
  field: () => 'signed_page_url',
  icon: () => 'fa-link',
});
const emit = defineEmits(['click', 'reload']);
const { t } = useI18n();
const { showSnackMessage, handleError } = useErrorStore();
async function copySignedUrl() {
  emit('click');
  try {
    await window.navigator.clipboard.writeText(props.model[props.field]);
    showSnackMessage(t('url.copied'), 'success');
  }
  catch (error) {
    handleError(error, t('url.copy_failed'));
  }
}
</script>
